import { PageType } from "@tvg/product-listing-url/lib/Types/types";
import { createContext, useContext } from "react";
import { Brand } from "types/common";

export interface GlobalConfig {
  brand: Brand;
  pageType: PageType;
  searchTerm?: string;
}

const GlobalConfigContext = createContext<GlobalConfig>({} as GlobalConfig);
GlobalConfigContext.displayName = "GlobalConfigContext";

export const { Provider: GlobalConfigProvider } = GlobalConfigContext;

const useGlobalConfig = () => useContext(GlobalConfigContext);
export default useGlobalConfig;
